import { pxArrayToRem, pxToRem } from '@archipro-design/aria';
import type { StyleRule } from '@archipro-design/aria';

export const VariantPricing: StyleRule = ({ theme }) => ({
    padding: pxArrayToRem([38, 0, 0, 0]),
    color: theme.siteVariables.colors.charcoal[250],
    fontSize: pxToRem(22),
    lineHeight: pxToRem(22),
    fontWeight: 400,
});

export const PricePrefix: StyleRule = ({ theme }) => ({
    fontSize: pxToRem(16),
    lineHeight: pxToRem(16),
    ...theme.siteVariables.textStyles.Text.Roman55,
    color: theme.siteVariables.colors.grey[300],
    marginBottom: pxToRem(2),
});

export const RetailPrice: StyleRule = ({ theme }) => ({
    fontSize: pxToRem(16),
    color: theme.siteVariables.colors.grey[300],
    lineHeight: pxToRem(16),
    marginBottom: pxToRem(2),
});

export const Price: StyleRule = ({ theme }) => ({
    fontSize: pxToRem(22),
    ...theme.siteVariables.textStyles.Heading.Roman55,
    lineHeight: pxToRem(22),
});

export const MaxPriceHyphen: StyleRule = () => ({
    margin: pxArrayToRem([0, 11, 0, 11]),
});

export const PricePOA: StyleRule = () => ({
    fontSize: pxToRem(22),
    lineHeight: pxToRem(22),
    textDecoration: 'underline',
    cursor: 'pointer',
});

export const Subtitle: StyleRule = ({ theme }) => ({
    fontSize: pxToRem(16),
    lineHeight: pxToRem(16),
    marginTop: pxToRem(12),
    color: theme.siteVariables.colors.grey[300],
    ...theme.siteVariables.textStyles.Text.Roman55,
});
